export class CustomerSubmitModel {
    sold_to_code: string;
    ship_to_code: string;
    payer_code: string;
    sales_area: string;
    salesrep_code: string;
    setting_id: string;
    storage_location: string
    plant: string
  }


// WEBPACK FOOTER //
// ./src/models/sap/customersubmit.model.ts